export { AgmSnazzyInfoWindowModule } from './snazzy-info-window.module';
export { AgmSnazzyInfoWindow } from './directives/snazzy-info-window';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/@agm/snazzy-info-window/index.js
// module id = ../../../../@agm/snazzy-info-window/index.js
// module chunks = vendor